import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationSoundService {
  private audioContext: AudioContext | null = null;

  /**
   * Plays a short two-tone chime using the Web Audio API.
   * Gracefully no-ops if the browser blocks audio before user interaction.
   */
  play(): void {
    try {
      if (!this.audioContext) {
        this.audioContext = new AudioContext();
      }

      const ctx = this.audioContext;

      if (ctx.state === 'suspended') {
        ctx.resume();
      }

      this.playTone(ctx, 830, ctx.currentTime, 0.12);
      this.playTone(ctx, 1100, ctx.currentTime + 0.14, 0.12);
    } catch {
      // Web Audio API unavailable or blocked — fail silently
    }
  }

  private playTone(
    ctx: AudioContext,
    frequency: number,
    startTime: number,
    duration: number
  ): void {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = 'sine'; // clean tone
    oscillator.frequency.setValueAtTime(frequency, startTime);

    // Smooth envelope (important for notification feel)
    gain.gain.setValueAtTime(0, startTime);
    gain.gain.linearRampToValueAtTime(0.25, startTime + 0.02); // quick attack
    gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration); // smooth decay

    oscillator.connect(gain);
    gain.connect(ctx.destination);

    oscillator.start(startTime);
    oscillator.stop(startTime + duration);
  }
}
